<form
  #formElRef
  novalidate
  (keydown.enter)="_onEnter($event)"
  (submit)="_onSubmit($event)">
  <ng-content></ng-content>
</form>
